import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/products/{creatorSlug}/{productSlug}/video';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['DELETE'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const deleteVideo = async ({ creatorSlug, productSlug }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorSlug, productSlug });
  const response = await noodleApiClient.delete(path);
  return response.data;
};

export default deleteVideo;
